/*
 * @Author: mayanxia 
 * @Date: 2022-05-07 16:49:41 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2024-01-02 17:29:46
 */

<template>
    <a-modal
      :width="modalWidth"
      :visible="visible"
      :title="title"
      :maskClosable="maskClosable"
      destroyOnClose
      :confirmLoading="confirmLoading"
      @ok="handleSubmit"
      @cancel="handleCancel"
      :cancelText="$t('关闭')"
      wrapClassName="ant-modal-cust-warp"
      >
      <template slot="footer">
        <a-button key="close" @click="handleCancel">
          {{ $t('关闭') }}
        </a-button>
      </template>
      <div class="form-contain">
        <a-divider orientation="left">{{ $t('基本数据') }}</a-divider>
        <detail-list>
          <detail-list-item :term="$t('设备编号')">{{model.meterId}}</detail-list-item>
          <detail-list-item :term="$t('设备名称')">{{model.deviceName}}</detail-list-item>
          <detail-list-item :term="$t('设备安装地址')">{{model.deviceLocation}}</detail-list-item>
        </detail-list>
        <a-layout id="components-layout-demo-top-side">
          <a-layout-content>
            <a-layout style="padding: 24px 0; background: #fff">
              <a-select default-value="" style="width: 200px" v-model="commandKey" @change="handleClick" :placeholder="$t('选择命令')">
                <a-select-opt-group>
                  <span slot="label">{{ $t('读命令') }}</span>
                  <a-select-option v-for="item in readCommandList" :key="item.key" :value="item.key">
                    {{ $t(item.title) }}
                  </a-select-option>
                </a-select-opt-group>
                <a-select-opt-group :label="$t('写命令')">
                  <a-select-option v-for="item in writeCommandList" :key="item.key" :value="item.key">
                    {{ $t(item.title) }}
                  </a-select-option>
                </a-select-opt-group>
              </a-select>
              <a-layout-content :style="{ padding: '0 24px',margin: '24px 0' }">
                <h2>{{commandName}}</h2><a-divider />
                <!-- 设置网络参数 -->
                <a-form-model v-if="commandKey == 17" ref="formModel" :model="formModel" :rules="rules" :colon="false">
                  <a-row :gutter="16">
                    <a-col :span="8">
                      <a-form-model-item :label="$t('IP地址')" prop="netIp">
                        <a-input v-model="formModel.netIp"/>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item :label="$t('端口号')" prop="netPort">
                        <a-input-number v-model="formModel.netPort" :min="0" :max="65535" :precision="0" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </a-form-model>
                <!-- 设置阀门角度 -->
                <a-form-model v-else-if="commandKey == 19" ref="formModel" :model="formModel" :rules="rules" :colon="false">
                <a-row :gutter="16">
                  <a-col :span="14">
                    <a-form-model-item  :label="$t('阀门角度')" prop="valveOpening" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input-number v-model="formModel.valveOpening"  :placeholder="$t('请输入阀门角度')" :min="0" :max="90" :precision="0" style="width:50%"></a-input-number>
                    </a-form-model-item>
                  </a-col>
                </a-row>
                </a-form-model> 
                <!-- 设置采集间隔 -->
                <a-form-model v-else-if="commandKey == 20" ref="formModel" :model="formModel" :rules="rules" :colon="false">
                  <a-row :gutter="16">
                    <a-col :span="14">
                      <a-form-model-item  :label="$t('采集间隔(分钟)')" prop="upDataInterval" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input-number v-model="formModel.upDataInterval"  :placeholder="$t('请输入采集间隔')" :min="0" :max="255" :precision="0" style="width:50%"></a-input-number>
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </a-form-model> 
                <!-- 设置上报时间 -->
                <a-form-model v-else-if="commandKey == 21" ref="formModel" :model="formModel" :rules="rules" :colon="false">
                  <a-row :gutter="16">
                    <a-col :span="8">
                      <a-form-model-item  :label="$t('0点分钟值')" prop="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input-number v-model="formModel.minite001"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                        <a-input-number v-model="formModel.minite002"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item  :label="$t('1点分钟值')" prop="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input-number v-model="formModel.minite011"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                        <a-input-number v-model="formModel.minite012"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item  :label="$t('2点分钟值')" prop="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input-number v-model="formModel.minite021"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                        <a-input-number v-model="formModel.minite022"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item  :label="$t('3点分钟值')" prop="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input-number v-model="formModel.minite031"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                        <a-input-number v-model="formModel.minite032"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item  :label="$t('4点分钟值')" prop="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input-number v-model="formModel.minite041"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                        <a-input-number v-model="formModel.minite042"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item  :label="$t('5点分钟值')" prop="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input-number v-model="formModel.minite051"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                        <a-input-number v-model="formModel.minite052"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item  :label="$t('6点分钟值')" prop="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input-number v-model="formModel.minite061"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                        <a-input-number v-model="formModel.minite062"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item  :label="$t('7点分钟值')" prop="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input-number v-model="formModel.minite071"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                        <a-input-number v-model="formModel.minite072"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item  :label="$t('8点分钟值')" prop="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input-number v-model="formModel.minite081"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                        <a-input-number v-model="formModel.minite082"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item  :label="$t('9点分钟值')" prop="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input-number v-model="formModel.minite091"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                        <a-input-number v-model="formModel.minite092"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item  :label="$t('10点分钟值')" prop="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input-number v-model="formModel.minite101"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                        <a-input-number v-model="formModel.minite102"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item  :label="$t('11点分钟值')" prop="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input-number v-model="formModel.minite111"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                        <a-input-number v-model="formModel.minite112"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item  :label="$t('12点分钟值')" prop="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input-number v-model="formModel.minite121"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                        <a-input-number v-model="formModel.minite122"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item  :label="$t('13点分钟值')" prop="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input-number v-model="formModel.minite131"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                        <a-input-number v-model="formModel.minite132"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item  :label="$t('14点分钟值')" prop="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input-number v-model="formModel.minite141"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                        <a-input-number v-model="formModel.minite142"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item  :label="$t('15点分钟值')" prop="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input-number v-model="formModel.minite151"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                        <a-input-number v-model="formModel.minite152"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item  :label="$t('16点分钟值')" prop="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input-number v-model="formModel.minite161"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                        <a-input-number v-model="formModel.minite162"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item  :label="$t('17点分钟值')" prop="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input-number v-model="formModel.minite171"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                        <a-input-number v-model="formModel.minite172"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item  :label="$t('18点分钟值')" prop="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input-number v-model="formModel.minite181"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                        <a-input-number v-model="formModel.minite182"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item  :label="$t('19点分钟值')" prop="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input-number v-model="formModel.minite191"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                        <a-input-number v-model="formModel.minite192"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item  :label="$t('20点分钟值')" prop="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input-number v-model="formModel.minite201"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                        <a-input-number v-model="formModel.minite202"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item  :label="$t('21点分钟值')" prop="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input-number v-model="formModel.minite211"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                        <a-input-number v-model="formModel.minite212"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item  :label="$t('22点分钟值')" prop="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input-number v-model="formModel.minite221"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                        <a-input-number v-model="formModel.minite222"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item  :label="$t('23点分钟值')" prop="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input-number v-model="formModel.minite231"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                        <a-input-number v-model="formModel.minite232"  :placeholder="$t('请输入分钟值')" :min="0" :max="59" :precision="0" style="width:50%"></a-input-number>
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </a-form-model>
                <!-- 设置阀门状态 -->
                <a-form-model v-else-if="commandKey == 22" ref="formModel" :model="formModel" :rules="rules" :colon="false">
                  <a-row :gutter="16">
                    <a-col :span="14">
                      <a-form-model-item  :label="$t('阀门状态')" prop="valveStatus" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-select v-model="formModel.valveStatus">
                          <a-select-option :value="0">{{ $t('关阀') }}</a-select-option>
                          <a-select-option :value="1">{{ $t('开阀') }}</a-select-option>
                        </a-select>
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </a-form-model> 
                <a-form-model 
                    v-else
                    ref="formModel"
                    :model="formModel"
                    :rules="rules"
                    :colon="false"
                >
                </a-form-model>
              </a-layout-content> 
            </a-layout>
          </a-layout-content>
        </a-layout>
        <a-row>
          <a-col :span="7">
          </a-col>
          <a-col :span="8">
            <a-button type="primary" block size="large" @click="handleSubmit">
              {{ $t('加入队列') }}
            </a-button>
          </a-col>
        </a-row>
      </div>
    </a-modal>
</template>

<script>
import i18n from '@/i18n'
  import { postAction } from '@/api/manage'
  import { isNull,isUndefinedAndNull } from '@/utils/validate'
  import {paramsToFormData} from '@/utils/util'
  import {netTypeObj} from '@/utils/constants/protocolConstant'
  import moment from 'moment'
  import { USER_AUTH} from "@/store/mutation-types"
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  const originalReadCommandList = [
    {key: 1, title: i18n.t('读采集器NB网络参数')},
    {key: 2, title: i18n.t('读取采集间隔')},
    {key: 3, title: i18n.t('读取自动上传时间点')},
  ]
  const originalWriteCommandList = [
    {key: 17, title: i18n.t('写采集器NB网络参数')},
    //{key: 18, title: '阀门角度校正'},
    //{key: 19, title: '设置阀门角度'},
    {key: 20, title: i18n.t('设置采集间隔')},
    {key: 21, title: i18n.t('设置自动上传时间')},
    {key: 22, title: i18n.t('设置采集器阀门控制')},
  ]
  export default {
    name: 'PartValveCommandModal',
    components: {
      DetailList,
      DetailListItem
    },
    data () {
      return {
        netTypeObj,
        modalWidth:1000,
        visible: false,
        confirmLoading: false,
        formModel: {
          valveOpening: 90,
          upDataInterval: 30
        },
        timings:{},
        model: {},
        commandKey: undefined,
        originalReadCommandList,
        originalWriteCommandList,
        readCommandList: originalReadCommandList,   //读命令
        writeCommandList: originalWriteCommandList, //写命令
        value: 1,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 18 },
        },
        maskClosable:false,
        url: {
          sendCommand: '/jeecg-charge/part/partValveCommand/addCommand'
        },
        cmd: {
          1: '8110_01',
          2: '8105_01',
          3: '8104_01',
          17: '8110_04',
          18: 'a029_04',
          19: 'a02a_04',
          20: '8105_04',
          21: '8104_04',
          22: 'a017_04',
        }  
      }
    },
    computed: {
        title() {
            return this.$t('命令下发')
        },
        rules() {
            return {
              valveOpening: [{ required: true, message: this.$t('请输入阀门角度!') }],
              netIp: [{
                required: false,
                pattern: /^((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})(\.((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})){3}$/,
                message: this.$t('IP输入有误')
              }],
              netPort: [{
                required: false,
                pattern: /^([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/,
                message: this.$t('端口号输入有误')
              }],
              upDataInterval: [{ required: true, message: this.$t('请输入采集间隔!') }],
              valveStatus: [{ required: true, message: this.$t('请选择阀门状态!') }],
            }
        },
        commandName() {
            let commandKey = this.commandKey
            console.log(parseInt(commandKey))
            if(isUndefinedAndNull(commandKey)) {
                return "";
            }
            else if(parseInt(commandKey)<17) {
                console.log("小于17")
                console.log()
                let index = this.readCommandList.findIndex((item)=>item.key == commandKey)
                return this.readCommandList[index].title;
            }else{
                let index = this.writeCommandList.findIndex((item)=>item.key == commandKey)
                return this.writeCommandList[index].title;
            }
        }
    },
    methods: {
      filterAuth() {
        let permissionList = [];
        let authList = JSON.parse(sessionStorage.getItem(USER_AUTH) || "[]");
        console.log(authList)
        for (let auth of authList) {
          if(auth.type != '2') {
            permissionList.push(auth);
          }
        }
        if (permissionList === null || permissionList === "" || permissionList === undefined||permissionList.length<=0) {
          this.commandList = []
          return;
        }
        let permissions = [];
        for (let item of permissionList) {
          if(item.type != '2'){
            //update--begin--autor:wangshuai-----date:20200729------for：按钮权限，授权标识的提示信息是多个用逗号分隔逻辑处理 gitee#I1OUGU-------
            if(item.action){
              if(item.action.includes(",")){
                let split = item.action.split(",")
                for (let i = 0; i <split.length ; i++) {
                  if(!split[i] ||split[i].length==0){
                    continue;
                  }
                  permissions.push(split[i]);
                }
              }else{
                permissions.push(item.action);
              }
            }
            //update--end--autor:wangshuai-----date:20200729------for：按钮权限，授权标识的提示信息是多个用逗号分隔逻辑处理 gitee#I1OUGU------
          }
        }
        console.log(permissions)
        let readCmdList = []
        for(let item of this.originalReadCommandList) {
          if(permissions.includes('oldcommand'+item.key)) {
            readCmdList.push(item)
          }
        }
        this.readCommandList = readCmdList
        let writeCmdList = []
        for(let item of this.originalWriteCommandList) {
          if(permissions.includes('oldcommand'+item.key)) {
            writeCmdList.push(item)
          }
        }
        this.writeCommandList = writeCmdList
      },
      handleClick(e) {
        this.$nextTick(() => {
          if (this.$refs.formModel !==undefined) {
            this.$refs.formModel.clearValidate()
          }
        })
        console.log('click ', e.key);
      },
      moment,
      onChange(time, timeString) {
        console.log(time, timeString);
      },
      edit(record) {
        //this.filterAuth();
        this.visible = true;
        this.model = Object.assign({}, record);
        this.formModel.meterId = record.meterId
      },
      handleSubmit() {
        console.log(this.formModel)
        if(isUndefinedAndNull(this.commandKey)) {
          this.$message.error(this.$t("请先选择命令"))
          return
        }
        this.$refs.formModel.validate(valid => {
          if (valid) {
            this.confirmLoading = true
            this.sendCommand(this.setCommandParams())
          }
        })   
      },
      onOk(value) {
        console.log('onOk: ', value);
      },
      handleCancel() {
        this.close()
      },
      close () {
        this.$emit('close');
        this.commandKey = this.$options.data.call(this).commandKey;
        this.formModel = this.$options.data.call(this).formModel;
        this.$nextTick(()=>{
          if (this.$refs.formModel !== undefined) {
            this.$refs.formModel.resetFields();
          }
        })
        this.visible = false;
      },
      setCommandParams() {
        let params =  {};
        params.meterId = this.formModel.meterId;
        params.cmd = this.cmd[this.commandKey];
        params.meterType = this.model.meterType;
        let cmdParam = {};
        if (this.commandKey == 1) {
            params.controlCode = "01";
          // 读取NB网络参数
          
        }
        if (this.commandKey == 17) {
            params.controlCode = "04";
            cmdParam.netIp = this.formModel.netIp;
            cmdParam.netPort = this.formModel.netPort;
          // 设置NB网络参数
        }else if (this.commandKey == 18) {
            // 阀门角度校正
            params.controlCode = "04";
            cmdParam.newMeterId = this.formModel.newMeterId;
        }else if(this.commandKey == 19) {
            // 设置阀门角度
            params.controlCode = "04";
            cmdParam.valveOpening = this.formModel.valveOpening
        }else if(this.commandKey == 20) {
            // 设置采集间隔
            params.controlCode = "04";
            cmdParam.upDataInterval = this.formModel.upDataInterval
        }else if(this.commandKey == 21) {
            // 设置自动上传时间
            params.controlCode = "04";
            cmdParam = Object.assign({},this.formModel);
            if(this.formModel.upDataInterval) {
              delete cmdParam['upDataInterval'];
            }
            if(this.formModel.valveOpening) {
              delete cmdParam['valveOpening'];
            }
            console.log(this.formModel)
        }else if(this.commandKey == 22) {
            // 电子阀设置阀门状态
            params.controlCode = "04";
            cmdParam.valveStatus = this.formModel.valveStatus == 1?'55':'99'
        }else if(this.commandKey == 2) {
            // 读取采集间隔
            params.controlCode = "01";
        }else if(this.commandKey == 3) {
            // 读取自动上传时间点
            params.controlCode = "01";
        }
        
        params.cmdParam = JSON.stringify(cmdParam);
        return params
      },
      // 协议下发命令
      sendCommand(params) {
        let formData = paramsToFormData(params)
        console.log(params);
        postAction(this.url.sendCommand, formData).then((res) => {
          this.confirmLoading = false;
          if (res.success && res.code == 0) {
            this.$message.success(res.message)
            this.$emit('ok')
            this.close()
          } else {
            this.$message.error(res.message)
          }
        })
      },
    }
  }
</script>

<style scoped>
.ant-row{
  margin-top: 8px;
}
.ant-form-item{
  margin-bottom: 8px;
}
.detail-list >>> .content{
  line-height: normal;
}
.character {
 margin: 10px;
 margin-left: 50px;
 font-size: 15px;
}
.form-contain{
  max-height: 60vh;
  overflow-y: scroll;
  overflow-x: hidden;
}
.form-contain >>> .ant-divider-inner-text{
  color: rgba(24,144,255,0.85);
  font-size: 16px;
}
</style>